<template>
  <div class="col-md-8 dragme" v-if="user.access > 2">
    <div class="portlet light">
      <i class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
      <div class="portlet-title tabbable-line">
        <div class="caption">
          <i class="icon-globe font-dark hide"></i>
          <span class="caption-subject font-dark bold uppercase">CALENDAR</span>
        </div>
      </div>
      <div class="portlet-body">
        <calendar-widget type="widget"></calendar-widget>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import Spinner from '@/components/Spinner';
  import CalendarCRUD from '@/components/widgets/CalendarCRUD';
  export default {
    components: {
      'vue-spinner': Spinner,
      'calendar-widget': CalendarCRUD
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
      }),
    }
  }
</script>
<style scoped>
  .portlet-body {
    padding-top: 0px;
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// Calendar.vue?17ba3e1a